import { heroStats, heroQuick } from "@/mocks/homeData";

const live = [
  { tag: "商业", text: "某平台抽成新规发酵，商户联盟要求重谈分成" },
  { tag: "消费", text: "即食燕麦成分争议，品牌方回应称将送第三方复检" },
  { tag: "娱乐", text: "演唱会被曝大量回流票加价，票务平台展开排查" },
];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      {/* soft warm radial wash (light shell, subtle) */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -left-40 top-0 h-[420px] w-[420px] rounded-full bg-primary-500/8 blur-3xl" />
        <div className="absolute -right-32 bottom-0 h-[360px] w-[360px] rounded-full bg-accent-500/10 blur-3xl" />
      </div>

      <div className="relative mx-auto grid max-w-[1240px] grid-cols-1 items-center gap-8 px-4 py-10 md:px-6 md:py-14 lg:grid-cols-[1.15fr_0.85fr] lg:gap-10">
        {/* Text-first */}
        <div className="w-full">
          <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-background-200 bg-background-50 px-3 py-1 text-xs text-foreground-600">
            <span className="flex h-1.5 w-1.5 items-center justify-center rounded-full bg-primary-500">
              <span className="h-1.5 w-1.5 animate-ping rounded-full bg-primary-500/70" />
            </span>
            实时更新中 · 数据截至今日
          </div>

          <h1 className="max-w-2xl font-heading text-[28px] font-bold leading-[1.3] md:text-5xl md:leading-[1.25]">
            黑料站 ——
            <span className="text-primary-600"> 全站内容一站速览</span>
          </h1>
          <p className="mt-5 max-w-xl text-[15px] leading-relaxed text-foreground-600 md:text-base">
            从商业内幕到消费舆情，从行业观察到时事追踪。按频道、分区、专题、板块、栏目、目录六条路径，
            快速定位黑料站全站内容，追更、求证、看榜都在这里。
          </p>

          {/* stats */}
          <div className="mt-7 flex flex-wrap items-center gap-x-8 gap-y-4">
            {heroStats.map((s) => (
              <div key={s.label} className="flex items-center gap-3">
                <span className="font-display text-3xl font-bold tracking-tight text-foreground-950 md:text-4xl">
                  {s.num}
                </span>
                <span className="text-sm text-foreground-500">{s.label}</span>
              </div>
            ))}
          </div>

          {/* quick entries */}
          <div className="mt-5 flex flex-wrap items-center gap-2">
            {heroQuick.map((q, i) => (
              <a
                key={q}
                href="#entry"
                className="inline-flex items-center gap-1 rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900 hover:bg-secondary-200"
              >
                <i className={i === 0 ? "ri-flashlight-line" : "ri-link"} aria-hidden="true" />
                {q}
              </a>
            ))}
          </div>

          {/* CTA */}
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#entry"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600"
            >
              开始浏览内容
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </a>
            <a
              href="#rank"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-2.5 text-sm font-medium text-foreground-800 hover:border-background-400"
            >
              <i className="ri-fire-line text-accent-600" aria-hidden="true" />
              查看今日热度榜
            </a>
          </div>
        </div>

        {/* Supporting visual: live mini feed card */}
        <div className="w-full">
          <div className="rounded-xl border border-background-200 bg-background-50 p-4 md:p-5">
            <div className="mb-3 flex items-center justify-between">
              <div className="flex items-center gap-2">
                <span className="flex h-2 w-2 items-center justify-center rounded-full bg-primary-500" />
                <span className="text-sm font-semibold text-foreground-950">实时热讯速递</span>
              </div>
              <span className="text-xs text-foreground-400">自动刷新</span>
            </div>
            <ul className="divide-y divide-background-100">
              {live.map((it, i) => (
                <li key={i} className="flex items-start gap-3 py-3">
                  <span className="mt-0.5 inline-flex shrink-0 items-center rounded bg-primary-100 px-1.5 py-0.5 text-[11px] font-medium text-primary-700">
                    {it.tag}
                  </span>
                  <p className="line-clamp-2 text-[13px] leading-relaxed text-foreground-700">{it.text}</p>
                  <span className="ml-auto mt-1 shrink-0 font-display text-xs font-semibold text-accent-600">
                    {["98", "94", "87"][i]}
                  </span>
                </li>
              ))}
            </ul>
            <a href="#feed" className="mt-2 flex items-center justify-center gap-1 rounded-md bg-background-100 py-2 text-xs text-foreground-700 hover:bg-background-200">
              查看更多短讯
              <i className="ri-arrow-down-s-line" aria-hidden="true" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}